import * as serviceContext from './serviceContext';
import { BASE_URL_M_ADMIN } from "../config";

let options = {};
let headers = new Headers();
let token = sessionStorage.getItem('token');

headers.append('content-type', 'application/json');
headers.append('Authorization', `${token}`);

options.headers = headers;
options.redirect = 'follow';


export async function getVendorsData() {
    try {
        const response = await serviceContext.get(`${BASE_URL_M_ADMIN}madmin/VendorMaster`, null, options);
        const res = response.json();
        return res;
    } catch (error) {
        return error;
    }
}

export async function createVendors(data) {
    try {
        const response = await serviceContext.post(`${BASE_URL_M_ADMIN}madmin/VendorMaster`, JSON.stringify(data), options);
        const res = response.json();
        return res;
    } catch (error) {
        return error;
    }
}

export async function getVendorDetailsById(id) {
    try {
        const response = await serviceContext.get(`${BASE_URL_M_ADMIN}madmin/VendorMaster/${id}`, null, options);
        const res = response.json();
        return res;
    } catch (error) {
        return error;
    }
}

export async function updateVendorDetails(data) {
    try {
        const response = await serviceContext.put(`${BASE_URL_M_ADMIN}madmin/VendorMaster`, JSON.stringify(data), options);
        const res = response.json();
        return res;
    } catch (error) {
        return error;
    }
}